export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-18 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 text-center">
            关于虫虫动漫
          </h2>
          <div className="mt-8 bg-background-100 rounded-xl border border-background-200/70 p-6 md:p-8">
            <div className="flex flex-col md:flex-row gap-6 items-start">
              <div className="flex-1">
                <p className="text-sm text-foreground-700 leading-relaxed">
                  <strong>虫虫动漫</strong>诞生于对漫画的无限热爱。我们是一个专注于免费漫画与免费看漫画的在线平台，致力于为每一位漫画爱好者提供最优质的在线阅读体验。
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  从热血战斗到治愈日常，从经典长篇到新番连载，虫虫动漫收录了海量免费动漫全集，覆盖全品类题材。下拉式滚动浏览让阅读更顺畅，无需翻页等待，沉浸感十足。我们相信，好的漫画应该被更多人看到，而价格不应该是阻碍。因此，虫虫动漫始终坚持免费阅读，让每一位读者都能零门槛享受漫画的乐趣。
                </p>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
                  我们的团队每天都在努力，同步更新日本连载与国漫最新话，优化阅读体验，丰富内容库。目前平台已拥有超过10万部漫画资源，每日更新1000+话，服务超过500万活跃读者。未来，虫虫动漫将继续前行，打造更完善的免费漫画网站大全，让好漫画触手可及。
                </p>
                <div className="mt-4 flex flex-wrap gap-4">
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-primary-500"></i>
                    <span className="text-xs text-foreground-600">海量免费资源</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-primary-500"></i>
                    <span className="text-xs text-foreground-600">极速同步更新</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="ri-checkbox-circle-line text-primary-500"></i>
                    <span className="text-xs text-foreground-600">纯净阅读体验</span>
                  </div>
                </div>
              </div>
              <div className="w-full md:w-48 h-48 rounded-xl overflow-hidden bg-background-200 shrink-0">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20playful%20mascot%20illustration%20of%20a%20cute%20cartoon%20ladybug%20reading%20a%20colorful%20comic%20book%2C%20smiling%20expression%2C%20sitting%20on%20a%20stack%20of%20manga%20volumes%2C%20simple%20clean%20background%20with%20warm%20coral%20and%20cream%20tones%2C%20friendly%20and%20inviting%20style%2C%20vector%20flat%20illustration&width=400&height=400&seq=about-comic-01&orientation=squarish"
                  alt="虫虫动漫品牌吉祥物"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}